import { deliveryStatus } from '../config';
import { Region } from '@enums/RegionList';

export const RegionCheck = (regionId: Region): boolean => {
  return Object.keys(deliveryStatus)
    .map(x => parseInt(x))
    .includes(regionId);
};
